<template>
    <div
        class="modal fade"
        id="addNewOffice"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content p-2">
                <div class="modal-body">
                    <label>Search timezone by location</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        v-model="officeStore.q"
                    />
                    <div class="error-box" v-if="officeStore.officeExisted">
                        This timezone has been added to your list. Try searching
                        for other timezone.
                    </div>
                    <div
                        class="error-box"
                        style="background-color: #82DF6B;"
                        v-if="officeStore.officeAdded"
                    >
                        Timezone added.
                    </div>
                    <div class="my-2" v-for="item in officeStore.officeList">
                        <div
                            class="py-1 d-flex justify-content-between align-items-center"
                            style="cursor:pointer;"
                            @click="addOffice(item)"
                        >
                            <div>
                                <div class="timezone">
                                    {{ item.name }}
                                    {{
                                        officeStore.currentTimezone
                                            ? "(Current Location)"
                                            : ""
                                    }}
                                </div>
                                <div class="country">
                                    {{ item.country }} ({{ item.zone_name }})
                                </div>
                            </div>
                            <div class="gmt-offset">{{ item.gmt_offset }}</div>
                        </div>
                    </div>
                    <button
                        type="button"
                        class="btn btn-block mt-2 wfh-btn"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        Done
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["officeStore"],

    watch: {
        "officeStore.q"() {
            if (this.officeStore.q !== "") {
                this.searchTimezone();
            }
        }
    },

    methods: {
        async getOffice() {
            const res = await axios.get(
                "/timezones" +
                    (this.officeStore.q ? `?q=${this.officeStore.q}` : "")
            );
            this.officeStore.officeList = res.data.data;
        },

        addOffice(item) {
            this.officeStore.addOffice(item);
        },

        searchTimezone: _.debounce(async function() {
            this.officeStore.currentTimezone = false;
            this.officeStore.officeExisted = false;
            this.officeStore.officeAdded = false;
            await this.getOffice();
        }, 500)
    },

    mounted() {
        this.getOffice();
    }
};
</script>

<style scoped>
.timezone {
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
}

.country,
.gmt-offset {
    font-size: 14px;
    font-weight: 100;
    line-height: 17px;
}

.wfh-btn {
    border-radius: 6px;
    background-color: #5145ff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
    color: #fff;
}
</style>
